import { buildSearchEngine } from '@coveo/headless';
import config from '../../../temp/config';
import { extractValueByKey } from '../../../utils/helper';
import { ProductType } from '../../../utils/ProductTypes';

export const headlessEngineSubscriptions = buildSearchEngine({
  configuration: {
    accessToken: config.coveoAccessToken,
    organizationId: config.coveoOrganizationId,
    search: {
      pipeline: config.coveoSubscriptionPipeline,
      searchHub: config.coveoSearchHub,
    },
    preprocessRequest: (request: any, clientOrigin: any) => {
      const source = config.coveoSubscriptionProductSource;
      let filter = config.coveoSubscriptionProductFilter;

      const exclusion = `NOT @producttype=="${ProductType.TrainingCourses}" AND NOT @producttype=="${ProductType.StatisticsReport}"`;

      if (clientOrigin === 'searchApiFetch') {
        const body = JSON.parse(request.body);

        if (body.cq && body.cq !== '') {
          let accountNumber = extractValueByKey(body.cq, '@accountNumber').replaceAll('"', '');
          filter = filter.replaceAll('__ACCOUNTNUMBER__', accountNumber);
          body.aq = `${source} ${filter} ${exclusion}`;
        } else {
          body.aq = `${source} ${exclusion}`;
        }

        body.cq = '';
        request.body = JSON.stringify(body);
      }

      return request;
    },
  },
});

export default headlessEngineSubscriptions;
